import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { PAYOUT_CLAIM_ROUTES } from "../../constants";
import { TransactionsPage } from "./TransactionsPage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <TransactionsPage />
      <SupportSheet
        namespace="payout-claim"
        visible
        onClose={() => navigate(PAYOUT_CLAIM_ROUTES.TRANSACTIONS)}
      />
    </>
  );
});
